export default __webpack_public_path__ + "static/media/Thaumaturge's Belt of Prestige.a4da5a70.jpg";